import { AxiosInstance } from 'axios';
import { OrderClassification } from '@trukt/types/Order';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';
import { PaginatedResults } from '@trukt/types/PaginatedResults';

export type OrderClassificationSearchRequest = PaginatedQueryParams;
export type OrderClassificationSearchItem = OrderClassification;
export type OrderClassificationSearchResponse = PaginatedResults<OrderClassificationSearchItem>;

export class OrderClassificationService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: OrderClassificationSearchRequest) {
    return this.instance.get<OrderClassificationSearchResponse>('/orders/classifications', {
      params: request,
    });
  }
}
